<template>
  <div class="box2">
    <pageTitle
      title="成品项目指导专区"
      titleColor="#313433"
      titColor="#313433"
    />
    <img class="price" src="../../../assets/coursePage/design/box2/img01.png" />
    <div class="subject-box">
      <div class="scorll-box6">
        <div class="nav-box">
          <div
            :class="cur == index?'nav cur-nav':'nav'"
            v-for="(item, index) in listArr"
            :key="index"
            @click="changeCur(index, item)"
          >
            {{ item.name }}
            <i v-if="cur == index"></i>
          </div>
        </div>
      </div>
      <div>
        <!-- <swiper
          :options="swiperOption"
          ref="mySwiper"
          class="swiperitems"
        >
          <swiper-slide
            class="swiperwrap"
            v-for="(item, index) in listArr"
            :key="index"
          > -->
          <div  class="swiperwrap">
            <ul class="wrap">
              <li v-for="(item, index) in goodsArr" :key="index">
                <div class="left" >
                  <div class="video"  v-if="item.videoUrl">
                    <video
                      :id="item.id"
                       @click="onVideoClick(item,index)"
                       
                      :src="item.videoUrl"
                     :controls="isControls"
                      :show-fullscreen-btn="fullscreen"
                    ></video>
                    <div class="poster" v-if="!item.playStatus" @click="clickPoster(item,index)">
                      <img class="banner" :src="item.bannerUrl" />
                      <img class="play" src="../../../assets/coursePage/design/box2/icon-paly.png" />
                    </div>
                    
                  </div>
                 
                  <img v-else :src="item.bannerUrl" />
                </div>
                <div class="right" @click="buy(item)">
                  <h1>{{ item.name }}</h1>
                  <p>{{ item.description }}</p>
                  <a
                    >立即购买
                    <img
                      src="../../../assets/coursePage/design/box2/icon-right.png"
                  /></a>
                </div>
              </li>
            </ul>
          </div>
          <!-- </swiper-slide>
        </swiper> -->
      </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { categoryList, categoryGoods } from "../../../api/index.js";
import Vue from 'vue'
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      fullscreen: true,

      listArr: [],
      goodsArr: [],
      cur: 0,
      scroll: 0,
      isControls:false,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("nav-box")[0].scrollLeft =
              this.realIndex * 85;
          },
          click(e) {
            if (e.target.className == "open") {
              that.show = true;
            }
          },
        },
      },
    };
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // },

    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  watch: {
    cur: {
      handler(val) {
        this.getGoods(this.listArr[val].id);
      },
    },
  },
  created() {
    this.getList();
  },
  mounted(){
    if(/iPhone|iPod|iPad/i.test(navigator.userAgent)){
      this.isControls=true
    }
    // setTimeout(()=>{
      
    //   var video = document.getElementById('1350')  
    //   console.log(video,'video')
    //   video.addEventListener('click',(e)=>{
    //     e.stopPropagation();
    //     console.log(video.paused,'video.paused')
    //     if(video.paused){
    //       video.play();
    //       this.goodsArr[0].playStatus=true
    //       Vue.set(this.goodsArr,0,this.goodsArr[0])
    //     }else{
    //       video.pause();
    //       this.goodsArr[0].playStatus=false
    //       Vue.set(this.goodsArr,0,this.goodsArr[0])
    //     }
    //   })
         
    // },3000)
    
  },
  methods: {
    onVideoPause(item,index){
      // if(!/iPhone|iPod|iPad/i.test(navigator.userAgent)){
      //   item.playStatus=false
      //   Vue.set(this.goodsArr,index,item)
      // }
    },
    onVideoPlay(){
      // console.log('播放')
    },
    onVideoClick(item,index){
      this.$nextTick(()=>{
        var video = document.getElementById(item.id)  
  
        if(video.paused){
          video.play();
          this.goodsArr[index].playStatus=true
          Vue.set(this.goodsArr,index,this.goodsArr[index])
        }else{
          video.pause();
          if(!/iPhone|iPod|iPad/i.test(navigator.userAgent)){
            this.goodsArr[index].playStatus=false
            Vue.set(this.goodsArr,index,this.goodsArr[index])
          }
        }
      })
      // console.log('点击视频')
    },
    clickPoster(item,index){
      var video = document.getElementById(item.id)      
      video.play();
      item.playStatus=true
      Vue.set(this.goodsArr,index,item)
    },
    buy(item) {
      window.open(item.linkUrl);
    },
    onChange(index) {
    },
    getGoods(id) {
      let params = {
        categoryId: id,
        current: 1,
        size: 9999,
      };
      categoryGoods(params)
        .then((res) => {
          if (res.data.success) {
            this.goodsArr = res.data.data.records;
            this.goodsArr.forEach(item => {
              item.playStatus=false
           
            });
          }
        })
        .finally(() => {});
    },
    getList() {
      categoryList()
        .then((res) => {
          if (res.data.success) {
            this.listArr = res.data.data;
            if (res.data.data && res.data.data.length) {
              this.getGoods(res.data.data[0].id);
            }
          }
        })
        .finally(() => {});
    },
    showPop() {
      (this.show = true),
        this.mai(
          "JavaEE-就业课",
          "查看全部",
          0,
          this.projectList[this.cur].title
        );
    },
    changeCur(index, item) {
      // this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
    close() {
      this.showVideo = false;
    },
  },
};
</script>
<!-- <style>
*::-webkit-media-controls-start-playback-button {
  display: none ;
  -webkit-appearance: none;
}
*::-webkit-media-controls-panel {
  display: none ;
  -webkit-appearance: none;
}

*::--webkit-media-controls-play-button {
  display: none ;
  -webkit-appearance: none;
}
</style> -->
<style lang="less" scoped>
.box2 {
  padding: 80px 0 88px;
  width: 100%;
  background: #EFF8FE;
  min-height: 1008px;
  box-sizing: border-box;
  .price {
    width: 622px;
    display: block;
    margin: 48px auto 0;
  }
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    width: 78px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }
  .subject-box {
    position: relative;
    margin: 0 32px 0;
    background: #ffffff;
    box-shadow: 0px 0px 24px 0px #e2eaee;
    border-radius: 16px;
    padding: 32px 0;
    .swiperwrap {
      width: 686px;
      padding-bottom: 0;

      .wrap {
        padding: 22px 32px 0;
        li {
          margin-bottom: 32px;
          display: flex;
          align-items: center;
          background: url("../../../assets/coursePage/design/box2/bg-item.png")
            no-repeat;
          background-size: cover;
          height: 216px;
          box-sizing: border-box;
          padding: 32px 24px;
          background-position: center;
          .left {
            background: #ffffff;
            border-radius: 8px;
            width: 200px;
            height: 152px;
            margin-right: 32px;
            display: flex;
            align-items: center;
            .video{
              position: relative;
              width: 100%;
              height: 122px;
              display: flex;
            align-items: center;
              .poster{
                .banner{
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                
                  max-height: 100%;
                  border-radius: 8px;
                }
                .play{
                  width: 48px;
                  height: 48px;
                  display: block;
                  position: absolute;
                  left: 50%;
                  top: 50%;
                  transform:translate(-50%,-50%);
                }
              }
              
              video{
                width: 100%;
                max-height: 100%;
                border-radius: 8px;
                
              }
            }
           
            >img {
              width: 100%;
              max-height: 100%;
              border-radius: 8px;
              
            }
          }
          .right {
            h1 {
              font-family: PingFangSC, PingFang SC;
              font-weight: 600;
              font-size: 32px;
              color: #313433;
              line-height: 48px;
              text-align: left;
              font-style: normal;
              max-width: 342px;
              white-space: nowrap; /* 不换行 */
              overflow: hidden; /* 隐藏超出的内容 */
              text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
            }
            p {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #313433;
              line-height: 40px;
              text-align: left;
              font-style: normal;
              max-width: 342px;
              margin: 8px 0 16px;

              white-space: nowrap; /* 不换行 */
              overflow: hidden; /* 隐藏超出的内容 */
              text-overflow: ellipsis; /* 用省略号表示被隐藏的部分 */
            }
            a {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 26px;
              color: #165dff;
              line-height: 40px;
              text-align: center;
              font-style: normal;
              display: flex;
              align-items: center;
              img {
                width: 24px;
                display: block;
                margin-left: 4px;
              }
            }
          }
        }
        li:last-child {
          margin-bottom: 0;
        }
      }
    }

    .scorll-box6 {
      overflow-x: scroll;
      transition: all 0.2s;
      width: 100%;

      box-sizing: border-box;
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
    }
    .nav-box {
      height: 87px;
      display: flex;
      position: relative;
      display: flex;
      overflow-x: scroll;
      transition: all 0.2s;
      padding: 0 32px;
      .nav {
       
        height: 64px;
        padding: 0 20px;
        border-radius: 12px;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 64px;
        text-align: center;
        position: relative;
        flex-shrink: 0;
        i {
          position: absolute;
          left: 50%;
          bottom: -12px;
          transform: translateX(-50%);
          width: 24px;
          height: 12px;
          background: url("../../../assets/coursePage/design/box2/icon-arrow.png")
            no-repeat;
          background-size: cover;
        }
      }

      .cur-nav {
        background: #303433;
        color: #ffffff;
        position: relative;
      }
    }
  }

  .swiper-slide {
    // padding: 0px 40px;
    padding-bottom: 74px;

    .block {
      position: relative;
      margin: 0 auto;
      padding: 36px 32px;
      width: 686px;
      height: 688px;
      background: #ffffff;
      box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
      border-radius: 20px;
      border: 1px solid #ffffff;
      background-size: contain;
      background-repeat: no-repeat;
      // box-sizing: border-box;

      .open {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 30px;
        width: 100%;
        height: 140px;
        // background: #fff;
        background: linear-gradient(
          180deg,
          rgba(255, 255, 255, 0) 0%,
          #ffffff 40%,
          #fff 100%
        );
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 36px;
        box-sizing: border-box;

        img {
          margin-left: 8px;
          width: 32px;
          height: 32px;
        }
      }

      overflow: hidden;
      box-sizing: border-box;

      .block-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        height: 56px;
        .title {
          font-size: 28px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: #1d2129;
        }

        .play-btn {
          display: flex;
          align-items: center;
          width: 180px;
          height: 56px;
          background: linear-gradient(313deg, #1fd7cd 0%, #65bcff 100%);
          box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
          border-radius: 32px;

          font-size: 24px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #ffffff;

          .play {
            margin-left: 8px;
            margin-right: 12px;
            width: 40px;
            height: 40px;
            background-color: #ffffff;
            border-radius: 50%;
            box-shadow: 0px 0px 6px 0px #28a9ea;
            background-image: url("../../../assets/coursePage/ai/box8/play.png");
            background-size: 24px 24px;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }

      .into {
        margin-bottom: 24px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 40px;
      }
    }
  }

  .swiper-pagination-box5 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(75, 132, 250, 0.16);

    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 56px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #fff;
      box-sizing: border-box;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #1d2129;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../../assets/coursePage/ai/box8/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 26px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 44px;
      margin-bottom: 8px;
    }
    .intro {
      margin: 0px 0 40px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 24px;
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #2674ff;
      line-height: 56px;
    }

    .target {
      margin-bottom: 64px;
      font-size: 26px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      p {
        padding-left: 15px;
        position: relative;
        &::before {
          content: "";
          width: 4px;
          height: 4px;
          background: #4e5969;

          border-radius: 50%;

          top: 20px;
          display: block;
          position: absolute;
          left: 0;
        }
      }
    }
  }
}
</style>
